export default "__VITE_ASSET__C5679opb__"